import { normalizeSearchText } from '@gozoki/tools'

/** Tous les mots doivent apparaître dans au moins un champ, sans casse ni accents. */
export const matchesTextSearch = (
  fields: readonly (string | null | undefined)[],
  search: string,
): boolean => {
  const words = normalizeSearchText(search).split(/\s+/).filter(Boolean)
  if (words.length === 0) return true
  const normalized = fields.map((field) => normalizeSearchText(field ?? ''))
  return words.every((word) => normalized.some((field) => field.includes(word)))
}
